function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.188 1.938a.875.875 0 01.875.875v15a.875.875 0 01-.875.875h-3.75a1 1 0 00-1 1v3.625l-2.15-1.613a1 1 0 00-1.2 1.6l3.75 2.813a1 1 0 001.6-.8v-4.625h2.75a2.875 2.875 0 002.875-2.875v-15a2.875 2.875 0 00-2.875-2.876H6.563a2.875 2.875 0 00-2.875 2.876v5.624a1 1 0 102 0V2.814a.875.875 0 01.875-.876h20.625z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.938 12.188a1 1 0 00-1-1h-15a1 1 0 00-1 1v11.25a1 1 0 001 1h2.75v4.625a1 1 0 001.707.707l5.332-5.332h5.21a1 1 0 001-1v-11.25zm-2 1v9.25h-4.626a1 1 0 00-.707.292l-3.918 3.918v-3.21a1 1 0 00-1-1h-2.75v-9.25h13z"
}))));